import { render } from "./SettingsLegalPage.vue?vue&type=template&id=4c58191e&ts=true"
import script from "./SettingsLegalPage.vue?vue&type=script&lang=ts"
export * from "./SettingsLegalPage.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/paulbele/Code/repositories/maatoo-app-master/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__